<template>
    <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div class="download">
        <div class="logo" ><img :src="require('@/assets/navLogo.png')" height="30" alt=""></div>
        <h2 class="title" >填写以下问卷并提交<br>即可浏览及下载解决方案、产品手册、技术资料及培训讲座等</h2>
        <el-form :model="form" :rules="rules" ref="downloadForm" label-width="117px" :inline="true" >
          <div style="margin: 39px 0 27px 0" >1、请填写您的基本信息</div>
          <el-form-item label="姓名" prop="name" >
            <el-input v-model="form.name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone" >
            <el-input v-model="form.phone" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" >
            <el-input v-model="form.email" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="unit" >
            <el-input v-model="form.unit" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="部门/科室" prop="department" >
            <el-input v-model="form.department" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="职务/职称" prop="position" >
            <el-input v-model="form.position" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="2、您实验室是否含有样本库" prop="hasTissueBank" labelWidth="100%"  class="otherItem" >
            <el-radio-group v-model="form.hasTissueBank">
              <el-radio label="1">目前已有</el-radio>
              <el-radio label="2">目前没有，计划建设</el-radio>
              <el-radio label="3">目前没有，只是感兴趣</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="3、您感兴趣的产品（可多选）" prop="products" labelWidth="100%"  class="otherItem" >
            <el-checkbox-group v-model="form.products">
              <el-checkbox label="BioFactory临床数据与样本资源库管理系统" name="1"></el-checkbox>
              <el-checkbox label="MicrobioBank菌株库管理系统" name="2"></el-checkbox>
              <el-checkbox label="BioData数据采集系统" name="3"></el-checkbox>
              <el-checkbox label="BioMonitor生物资源运输监控管理平台" name="4"></el-checkbox>
              <el-checkbox label="BioCloud多中心生物资源共享平台" name="5"></el-checkbox>
              <el-checkbox label="BioCohort自然人群队列研究管理平台" name="6"></el-checkbox>
              <el-checkbox label="BioVision生物样本库数字孪生可视化大屏展示" name="7"></el-checkbox>
<!--              <el-checkbox label="人类遗传资源管理行政审批服务" name="8"></el-checkbox>-->
              <el-checkbox label="ISO20387技术咨询服务" name="9"></el-checkbox>
              <el-checkbox label="设备/耗材选型咨询服务" name="10"></el-checkbox>
              <el-checkbox label="场地布局规划咨询" name="11"></el-checkbox>
              <el-checkbox label="生物样本库其他服务" name="12"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="4、购买意向" prop="buy" labelWidth="100%"  class="otherItem otherItem1" >
            <el-radio-group v-model="form.buy">
              <el-radio label="1">三个月内采购</el-radio>
              <el-radio label="2">半年内采购</el-radio>
              <el-radio label="3">一年内采购</el-radio>
              <el-radio label="4">暂时没有采购计划</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="5、您希望以何种形式获取我们的团队支持以及您感兴趣的产品" prop="type" labelWidth="100%"  class="otherItem otherItem1" >
            <el-radio-group v-model="form.type">
              <el-radio label="1">要求唐颐销售上门拜访</el-radio>
              <el-radio label="2">产品演示（现场体验或测样）</el-radio>
              <el-radio label="3">要求销售报价</el-radio>
              <el-radio label="4">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="6、我要留言" labelWidth="100%" class="otherItem" >
            <el-input type="textarea" v-model="form.message" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="" prop="authorization1" labelWidth="100%"   class="otherItem authorization"  style="margin-bottom: 24px">
              <div style="display: flex;justify-content: space-between;width: 100%">
                  <div>
                     <el-checkbox-group v-model="form.authorization1">
                        <el-checkbox label="authorization1" >我已完整阅读并同意唐颐《个人信息保护政策》，并同意唐颐按照该政策处理我的个人信息。<span style="color: #f00;vertical-align: middle">*</span></el-checkbox>
                     </el-checkbox-group>
                  </div>
                  <div>
                      <span style="color: #f00;vertical-align: middle;margin-right: 10px">*</span><span style="color: #169bd5;cursor: pointer;" @click="dialogVisible=true">阅读《个人信息保护政策》</span>
                  </div>
              </div>
          </el-form-item>
          <el-form-item label="" prop="authorization2" labelWidth="100%"   class="otherItem authorization" >
            <el-checkbox-group v-model="form.authorization2">
              <el-checkbox label="authorization2">我同意唐颐通过电子邮件、电话、短信或其他方式向我发送有关唐颐产品或服务信息或与我取得联系。<span style="color: #f00;vertical-align: middle">*</span></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div class="downloadBtn"  @click="download">下载资料<img :src="require('@/assets/img/products/xiazai.png')" /></div>
        <el-dialog  :visible.sync="dialogVisible"  :lock-scroll="false" :show-close="false" width="40%" top="80px" class="privacyDialog">
          <div slot="title" style="padding: 0"></div>
          <div class="privacy">
              <div class="privacyTitle">个人信息保护政策</div>
              <div class="privacySpeech">尊敬的用户:</div>
              <div class="privacyContent">感谢您访问我们公司网站并申请下载相关资料。我们非常重视用户的个人信息保护,并严格遵循相关法律法规对用户个人信息进行收集、使用和披露。</div>
              <div class="privacyContent">现就我们在个人信息收集与使用方面的政策作如下说明:</div>
              <div class="privacyContent">1. 个人信息的收集范围:我们只会收集您在本网站下载资料时自愿提供的个人信息,主要包括您的姓名、单位名称、手机号码和邮箱地址。</div>
              <div class="privacyContent">2. 个人信息的使用目的:我们会使用您提供的个人信息完成资料下载服务、建立用户档案、用于下载数据的统计分析,以及将您的联系信息录入我们的客户关系管理系统,以便我们的销售团队在取得您的同意后与您联系。</div>
              <div class="privacyContent">3. 个人信息的披露方式:除非获得您的明确同意或法律法规要求,否则我们不会将您的个人信息披露、出售或租借给任何第三方。</div>
              <div class="privacyContent">4. 个人信息的保护措施:我们采取相关行业标准的安全防护措施来保护您的个人信息,防止数据丢失、被泄露、被未经授权访问或被修改。但因黑客攻击等技术原因造成的个人信息安全风险,我们不承担任何责任。</div>
              <div class="privacyContent">5. 您的权利:按照法律规定,您有权通过书面形式向我们查询、更正或删除您的个人信息。我们承诺遵循法律法规和道德规范收集和使用您的个人信息,并采取一切合理措施来保护您的隐私权和信息安全。</div>
              <div class="privacyContent">如果您对我们的个人信息保护政策或实践有任何疑问,请通过邮箱marketing@eternal-health.cn与我们联系。 谢谢您的理解与支持！</div>
              <div class="privacySignature">上海唐颐信息技术有限公司</div>
              <div class="privacyDate">2023年6月8日</div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible=false">取 消</el-button>
            <el-button type="primary" @click="dialogOk">确定并同意</el-button>
          </span>
        </el-dialog>
    </div>
    </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
  name:'Download',
  components: {ProductsMenu},
  data () {
    return {
        form:{
            products:[],
            authorization1:[],
            authorization2:[]
        },
        rules:{
            name:[
                { required: true, message: '请输入姓名', trigger: 'blur' },
            ],
            phone:[
                { required: true, message: '请输入手机', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (value === "") {
                        callback(new Error("请输入正确的手机号码"))
                    } else if (!/^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/.test(value)) {
                        callback(new Error("请输入正确的手机号码"))
                    } else {
                        callback()
                    }
                  },
                  message: "请输入正确的手机号码"
                }
            ],
            email:[
                { required: true, message: '请输入邮箱', trigger: 'blur' },
                {type: "email",message: "请输入正确的邮箱地址",trigger: ["blur", "change"]}
            ],
            unit:[
                { required: true, message: '请输入单位名称', trigger: 'blur' },
            ],
            department:[
                { required: true, message: '请输入部门/科室', trigger: 'blur' },
            ],
            position:[
                { required: true, message: '请输入职务/职称', trigger: 'blur' },
            ],
            hasTissueBank:[
                { required: true, message: '请选择您实验室是否含有样本库', trigger: 'blur' },
            ],
            products:[
                { type: 'array', required: true, message: '请至少选择一项您感兴趣的产品', trigger: 'change' }
            ],
            buy:[
                { required: true, message: '请选择您的购买意向', trigger: 'blur' },
            ],
            type:[
                { required: true, message: '请选择您的购买意向', trigger: 'blur' },
            ],
            authorization1:[
                { type: 'array', required: true, message: '请仔细阅读《个人信息保护政策》并同意', trigger: 'change' }
            ],
            authorization2:[
                { type: 'array', required: true, message: '请同意本公司通过上述信息与您进行联系', trigger: 'change' }
            ]
        },
        title:'个人信息保护政策',
        dialogVisible:false,

    }
  },
  methods:{
      download(){
         this.$refs.downloadForm.validate((valid) => {
          if (valid) {
            console.log(this.form)
            window.open("/doc/样本库宣传册.pdf")
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      productsSelect(src){
        this.$emit('productsSelect',src)
      },
      dialogOk(){
          this.form.authorization1 = ['authorization1']
          this.dialogVisible = false
      }
  }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .download{
        width: 1141px;
        box-sizing: border-box;
        margin: 213px auto 78px;
        padding: 28px 62px;
        box-shadow: 0px 0px 5px #dedede;
        .logo{
            text-align: right;
        }
        .title{
            text-align: center;
            font-size: 23px;
            line-height: 40px;
            font-weight: normal;
            padding-bottom: 20px;
            border-bottom: 1px solid #666;
        }
        .el-form{
            font-size: 14px;
            .el-form-item{
                /deep/
                .el-form-item__label{
                    padding-left: 32px;
                    box-sizing: border-box;
                    color: #333;
                    text-align: justify;
                    text-align-last: justify;
                }
                .el-input{
                    width: 212px;

                }
                /deep/
                .el-input__inner{
                    height: 23px;
                    line-height: 23px;
                    border-radius: 5px;
                }
            }
            /deep/
            .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
                vertical-align: sub;
            }
            .otherItem{
                width: 100%;
                /deep/
                .el-form-item__label{
                    padding-left: 0px;
                    box-sizing: border-box;
                    color: #333;
                    text-align: left;
                    text-align-last: left;
                    margin-bottom: 0px;
                    letter-spacing: 1px;
                }
                /deep/
                .el-form-item__content{
                    width: 100%;
                    /*padding-left: 2em;*/
                    box-sizing: border-box;
                    .el-radio-group,.el-checkbox-group{
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        box-sizing: border-box;
                        .el-radio,.el-checkbox{
                            letter-spacing: 1px;
                            width: 33%;
                            margin-right: 0;
                            padding-left: 30px;
                            box-sizing: border-box;
                        }
                    }
                }
                /deep/
                .el-form-item__error{
                  padding-left: 2em;
                }
            }
            /deep/
            .otherItem.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
                content: '';
            }
            /deep/
            .otherItem.is-required:not(.is-no-asterisk)>.el-form-item__label:after{
                content: '*';
                color: #F56C6C;
                margin-left: 4px;
                vertical-align: sub;
            }
            .otherItem1{
                .el-form-item__content{
                    .el-radio-group{
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        box-sizing: border-box;
                        .el-radio{
                            letter-spacing: 1px;
                            width: 100%;
                            margin-right: 0;
                            padding-left: 30px;
                            box-sizing: border-box;
                            margin-bottom: 20px;
                        }
                    }
                }
            }
            /deep/
            .el-radio__input.is-checked .el-radio__inner{
                border-color: #ed1d25;
                background: #ed1d25;
            }
            /deep/
            .el-radio__input.is-checked+.el-radio__label{
                color: #ed1d25;
            }
            /deep/
            .el-checkbox__input.is-checked .el-checkbox__inner{
                border-color: #ed1d25;
                background: #ed1d25;
            }
            /deep/
            .el-checkbox__input.is-checked+.el-checkbox__label{
                color: #ed1c25;
            }
            /deep/
            .el-input__inner:focus{
                border-color: #ed1c25;
            }
            /deep/
            .authorization .el-form-item__content{
              height: 28px;
              .el-checkbox-group .el-checkbox{
                padding-left: 0;
              }
            }
        }
        .downloadBtn{
          width: 112px;
          height: 26px;
          line-height: 26px;
          border-radius: 10px;
          font-size: 15px;
          color: #fff;
          background: #ed1c24;
          text-align: center;
          letter-spacing: 1px;
          margin-top: 10px;
          /*box-shadow: 0 0 2px #ed1c24;*/
          cursor: pointer;
          &:hover{
            box-shadow: 0 0 5px #ed1c24;
          }
          img{
            height: 18px;
            vertical-align: middle;
            margin-bottom: 3px;
          }
        }
    }
    .privacy{
        padding: 20px;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 1px;
        .privacyTitle{
            text-align: center;
            font-weight: bold;
            font-size: 18px;
        }
        .privacySpeech{
            /*font-weight: bold;*/
        }
        .privacyContent{
            text-indent: 2em;
        }
        .privacySignature{
            text-align: right;
        }
        .privacyDate{
            text-align: right;
        }
    }
    /deep/
    .dialog-footer {
        button:nth-child(2){
            span{
                color: #fff!important;
            }
        }
    }
    /deep/
    .privacyDialog .el-dialog__header{
        padding: 0;
    }
</style>
